import React from 'react'
import { useOverlayContainer } from '@firstbite/ui'
import { EmailsModal } from '../NewCompanyPage/Modals/EmailsModal/EmailsModal'

/**
 * `EmailsModal` that portals into the enclosing fb-ui Sheet instead of
 * `document.body`. When opened from inside a react-aria modal (the Action Center
 * apply/activity Sheet), react-aria's `ariaHideOutside` inerts everything outside
 * that Sheet — so a body-portaled modal renders but can't be clicked or closed.
 * Reading the Sheet's node from `useOverlayContainer()` and passing it as the
 * modal's `container` keeps it inside the interactive scope. Outside a Sheet the
 * hook returns `null`, so this falls back to the normal body portal.
 */
export const ScopedEmailsModal: React.FC<
  React.ComponentProps<typeof EmailsModal>
> = (props) => {
  const container = useOverlayContainer()
  return <EmailsModal {...props} container={container ?? undefined} />
}
